<template>
  <div class="CardHouses">
    <el-form ref="editForm" status-icon :model="editForm" :rules="rules" label-width="106px" size="small" class="bg-#fff mx-20 pr-30 py-20">
      <template v-if="!indexThis.add">
        <el-form-item
          label="所属项目："
          prop="communityId"
          :rules="{
            required: true,
            message: '所属项目不能为空',
            trigger: 'change',
          }"
        >
          <el-select v-model="editForm.communityId" filterable clearable placeholder="选择所属项目">
            <el-option v-for="item in searchCommunities" :key="item.communityId" :label="item.communityName" :value="item.communityId" />
          </el-select>
        </el-form-item>
        <el-form-item
          label="住户类型："
          prop="householdType"
          :rules="{
            required: true,
            message: '住户类型不能为空',
            trigger: 'change',
          }"
        >
          <el-radio v-model="editForm.householdType" :label="1">个人</el-radio>
          <el-radio v-model="editForm.householdType" :label="2">公司</el-radio>
        </el-form-item>
      </template>
      <template v-else>
        <el-form-item label="项目名称：" prop="communityId" label-width="96px" style="margin-left: 10px">
          {{ getCommunityName(previewForm.communityId) }}
        </el-form-item>
        <el-form-item label="住户类型：" prop="householdType" label-width="96px" style="margin-left: 10px">
          {{ dictType('residentType', editForm.householdType) }}
        </el-form-item>
      </template>
      <div v-if="editForm.householdType == 1">
        <div class="form-Title mx-20-2" style="margin-top: 30px">个人信息</div>
        <el-form-item label="住户姓名：" prop="householdName">
          <el-input v-angle="editForm.householdName" v-model="editForm.householdName" placeholder="填写住户姓名" clearable />
        </el-form-item>
        <el-form-item label="联系方式：" prop="householdPhone" label-width="96px" style="margin-left: 10px">
          <el-input v-angle="editForm.householdPhone" v-model="editForm.householdPhone" placeholder="填写手机号/座机号，座机号示例：02227565399" clearable />
        </el-form-item>
        <el-form-item label="身份证号：" prop="idCard" label-width="96px" style="margin-left: 10px">
          <el-input v-angle="editForm.idCard" v-model="editForm.idCard" placeholder="填写身份证号" clearable minlength="18" maxlength="18" @change="idCard(editForm.idCard)" />
        </el-form-item>
        <el-form-item label="住户性别：" prop="sex">
          <el-radio :disabled="sexdisabled" v-model="editForm.sex" :label="2">女</el-radio>
          <el-radio :disabled="sexdisabled" v-model="editForm.sex" :label="1">男</el-radio>
          <el-radio :disabled="sexdisabled" v-model="editForm.sex" :label="3">未知</el-radio>
        </el-form-item>
        <div class="form-Title mx-20-2" style="margin-top: 30px">住户标签</div>
        <el-form-item label="年龄标签：" prop="ageType">
          <el-radio :disabled="ageTypedisabled" v-model="editForm.ageType" :label="1">其他</el-radio>
          <el-radio :disabled="ageTypedisabled" v-model="editForm.ageType" :label="2">老年人</el-radio>
          <el-radio :disabled="ageTypedisabled" v-model="editForm.ageType" :label="3">婴幼儿</el-radio>
        </el-form-item>
        <el-form-item label="残障人士：" prop="isDisability">
          <el-radio v-model="editForm.isDisability" :label="0">否</el-radio>
          <el-radio v-model="editForm.isDisability" :label="1">是</el-radio>
        </el-form-item>
        <div class="form-Title mx-20-2" style="margin-top: 30px">紧急联系人</div>
        <el-form-item label="首选联系人：" prop="emergencyContactOne" label-width="96px" style="margin-left: 10px">
          <el-input v-angle="editForm.emergencyContactOne" v-model="editForm.emergencyContactOne" placeholder="填写首选联系人姓名" clearable />
        </el-form-item>
        <el-form-item label="联系方式：" prop="emergencyContactOnePhone" label-width="96px" style="margin-left: 10px">
          <el-input v-angle="editForm.emergencyContactOnePhone" v-model="editForm.emergencyContactOnePhone" placeholder="填写手机号/座机号，座机号示例：02227565399" clearable />
        </el-form-item>
        <el-form-item label="备用联系人：" prop="emergencyContactTwo" label-width="96px" style="margin-left: 10px">
          <el-input v-angle="editForm.emergencyContactTwo" v-model="editForm.emergencyContactTwo" placeholder="填写备用联系人姓名" clearable />
        </el-form-item>
        <el-form-item label="联系方式：" prop="emergencyContactTwoPhone" label-width="96px" style="margin-left: 10px">
          <el-input v-angle="editForm.emergencyContactTwoPhone" v-model="editForm.emergencyContactTwoPhone" placeholder="填写手机号/座机号，座机号示例：02227565399" clearable />
        </el-form-item>
      </div>
      <div v-if="editForm.householdType == 2">
        <div class="form-Title mx-20-2" style="margin-top: 30px">公司信息</div>
        <el-form-item label="公司名称：" prop="companyName">
          <el-input v-angle="editForm.companyName" v-model="editForm.companyName" placeholder="填写公司名称" clearable />
        </el-form-item>
        <el-form-item
          label="统一社会信用代码："
          prop="socialIdCard"
          label-width="96px"
          style="margin-left: 10px"
          :rules="{
            pattern: /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/,
            message: '统一社会信用代码格式不正确',
            trigger: 'change',
          }"
        >
          <el-input v-angle="editForm.socialIdCard" v-model="editForm.socialIdCard" placeholder="填写统一社会信用代码" clearable minlength="18" maxlength="18" />
        </el-form-item>
        <el-form-item label="法人姓名：" prop="juridicalPersonName" label-width="96px" style="margin-left: 10px">
          <el-input v-angle="editForm.juridicalPersonName" v-model="editForm.juridicalPersonName" placeholder="填写法人姓名" clearable minlength="18" maxlength="18" />
        </el-form-item>
        <el-form-item label="联系方式：" prop="companyContactPhone" label-width="96px" style="margin-left: 10px">
          <el-input v-angle="editForm.companyContactPhone" v-model="editForm.companyContactPhone" placeholder="填写手机号/座机号，座机号示例：02227565399" clearable />
        </el-form-item>
        <div class="form-Title mx-20-2" style="margin-top: 30px">公司联系人</div>
        <el-form-item label="付款联系人：" prop="payContactName" label-width="96px" style="margin-left: 10px">
          <el-input v-angle="editForm.payContactName" v-model="editForm.payContactName" placeholder="填写付款联系人姓名" clearable />
        </el-form-item>
        <el-form-item label="联系方式：" prop="payContactPhone" label-width="96px" style="margin-left: 10px">
          <el-input v-angle="editForm.payContactPhone" v-model="editForm.payContactPhone" placeholder="填写手机号/座机号，座机号示例：02227565399" clearable />
        </el-form-item>
        <el-form-item label="合同联系人：" prop="agreementContactName" label-width="96px" style="margin-left: 10px">
          <el-input v-angle="editForm.agreementContactName" v-model="editForm.agreementContactName" placeholder="填写合同联系人姓名" clearable />
        </el-form-item>
        <el-form-item label="联系方式：" prop="agreementContactPhone" label-width="96px" style="margin-left: 10px">
          <el-input v-angle="editForm.agreementContactPhone" v-model="editForm.agreementContactPhone" placeholder="填写手机号/座机号，座机号示例：02227565399" clearable />
        </el-form-item>
      </div>
    </el-form>
    <FixedTwoButton :activeClass="sidebarIsOpen ? 'width210' : 'width54'">
      <ELButton size="small" describe="重置" :myFunction="resetForm" />
      <ELButton size="small" describe="提交" isAsync :myFunction="submitForm" type="primary" />
    </FixedTwoButton>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import { householdInfoUpd, householdIndividualInfoIns, companyInfoIns, householdBaseInfoDetail } from '@/api/propertyManage'
import formatData from '@/utils/formatRequestData'

export default {
  inject: ['indexThis'],
  data() {
    return {
      drawer: false,
      editForm: {
        socialIdCard: '',
        householdType: 1,
        companyName: '',
        communityId: '',
      },
      householdType: '',
      ageTypedisabled: false,
      sexdisabled: false,
      rules: {
        householdName: [
          {
            required: true,
            message: '住户姓名不能为空',
            trigger: 'change',
          },
        ],
        householdPhone: [
          {
            pattern: /^(((0\d{2,3})?[0-9]{7,8})|(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8})$/,
            message: '联系方式格式不正确',
            trigger: 'change',
          },
        ],
        companyContactPhone: [
          {
            pattern: /^(((0\d{2,3})?[0-9]{7,8})|(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8})$/,
            message: '联系方式格式不正确',
            trigger: 'change',
          },
        ],
        emergencyContactTwoPhone: [
          {
            pattern: /^(((0\d{2,3})?[0-9]{7,8})|(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8})$/,
            message: '联系方式格式不正确',
            trigger: 'change',
          },
        ],
        emergencyContactOnePhone: [
          {
            pattern: /^(((0\d{2,3})?[0-9]{7,8})|(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8})$/,
            message: '联系方式格式不正确',
            trigger: 'change',
          },
        ],
        payContactPhone: [
          {
            pattern: /^(((0\d{2,3})?[0-9]{7,8})|(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8})$/,
            message: '联系方式格式不正确',
            trigger: 'change',
          },
        ],
        agreementContactPhone: [
          {
            pattern: /^(((0\d{2,3})?[0-9]{7,8})|(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8})$/,
            message: '联系方式格式不正确',
            trigger: 'change',
          },
        ],
        sex: [
          {
            required: true,
            message: '性别标签不能为空',
            trigger: 'change',
          },
        ],
        ownershipRelation: [
          {
            required: true,
            message: '住户角色不能为空',
            trigger: 'change',
          },
        ],
        administrativePost: [
          {
            required: true,
            message: '住户身份不能为空',
            trigger: 'change',
          },
        ],

        ageType: [
          {
            required: true,
            message: '年龄标签不能为空',
            trigger: 'change',
          },
        ],
        isDisability: [
          {
            required: true,
            message: '是否为残障人士不能为空',
            trigger: 'change',
          },
        ],
        companyName: [
          {
            required: true,
            message: '住户姓名不能为空',
            trigger: 'change',
          },
        ],
        idCard: [
          {
            pattern: /^(^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])\d{3}(\d|X|x)$)/,
            message: '身份证号码格式不正确',
            trigger: 'change',
          },
        ],
      },
      cloneFormData: {},
    }
  },
  watch: {
    'editForm.householdType': {
      handler() {
        if (!this.$refs.editForm) return
        this.$refs.editForm.clearValidate()
      },
    },
    'editForm.idCard': {
      handler(val) {
        if (!this.$refs.editForm) return
        if (val == '' || val == null) {
          this.ageTypedisabled = false
          this.sexdisabled = false
        } else {
          this.idCard(val)
        }
      },
    },
  },
  created() {
    this.init()
  },
  methods: {
    //通过身份证号计算年龄
    idCard(userCard) {
      var reg = /^(^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])\d{3}(\d|X|x)$)/
      var isUserId = reg.test(userCard)
      if (this.editForm.idCard == '') {
        this.ageTypedisabled = false
        this.editForm.ageType = 1
        this.sexdisabled = false
        this.editForm.sex = ''
        return
      }
      if (isUserId == false) {
        this.ageTypedisabled = false
        this.editForm.ageType = 1
        this.sexdisabled = false
        this.editForm.sex = ''
        return
      }
      //获取年龄
      var myDate = new Date()
      var month = myDate.getMonth() + 1
      var day = myDate.getDate()
      var age = myDate.getFullYear() - userCard.substring(6, 10) - 1
      if (userCard.substring(10, 12) < month || (userCard.substring(10, 12) == month && userCard.substring(12, 14) <= day)) {
        age++
      }
      if (age < 0) {
        ;(this.editForm.ageType = 1), (this.ageTypedisabled = true)
      }
      if (age < 4) {
        ;(this.editForm.ageType = 3), (this.ageTypedisabled = true)
      }
      if (age > 59) {
        ;(this.editForm.ageType = 2), (this.ageTypedisabled = true)
      }
      if (age > 3 && age < 60) {
        ;(this.editForm.ageType = 1), (this.ageTypedisabled = true)
      }
      //获取性别
      if (parseInt(userCard.substr(16, 1)) % 2 == 1) {
        this.editForm.sex = 1
        this.sexdisabled = true
      } else {
        this.editForm.sex = 2
        this.sexdisabled = true
      }
    },
    async submitForm() {
      const valid = await this.$refs.editForm.validate().catch(() => {})
      if (!valid) return false
      const submitFormData = this.diffEditForm(this.editForm, this.cloneFormData)
      if (!this.indexThis.add && this.judgeObjISEmpty(submitFormData)) return
      if (submitFormData.socialIdCard) {
        submitFormData = {
          ...submitFormData,
          idCard: submitFormData.socialIdCard,
        }
        delete submitFormData.socialIdCard
      }
      if (this.householdType == this.cloneFormData.householdType) {
        delete submitFormData.householdType
      } else {
        submitFormData = {
          ...submitFormData,
          householdType: this.cloneFormData.householdType,
        }
      }
      const { data: res } = await (!this.indexThis.add
        ? householdInfoUpd({ id: this.editForm.id, ...formatData(submitFormData), householdId: this.editForm.idEdit })
        : this.editForm.householdType === 1
        ? householdIndividualInfoIns(formatData(this.editForm))
        : companyInfoIns(formatData(this.editForm)))
      if (!res) return this.$message.error('编辑失败')
      this.$message.success('编辑成功')
      await this.indexThis.householdList()
      this.resetForm()
      this.indexThis.housesIndex = this.indexThis.housesList.length - 1
      this.init()
    },
    resetForm() {
      this.editForm = cloneDeep(this.cloneFormData)
    },

    // 获取详情
    async init() {
      const { data } = await householdBaseInfoDetail({
        id: this.indexThis.housesInfo.householdId,
      })
      if (!data) return
      if (this.indexThis.housesInfo.householdType == 1) {
        if (data.householdPersonInfo.idCard !== '') {
          this.idCard(data.householdPersonInfo.idCard)
        }
        this.editForm = {
          ...data.householdPersonInfo,
          householdType: 1,
          idEdit: this.indexThis.housesInfo.householdId,
        }
      }
      if (this.indexThis.housesInfo.householdType == 2) {
        this.editForm = {
          ...data.householdCompanyInfo,
          householdType: 2,
          idEdit: this.indexThis.housesInfo.householdId,
          socialIdCard: data.householdCompanyInfo.idCard,
        }
      }
      this.householdType = cloneDeep(this.editForm.householdType)
      this.cloneFormData = cloneDeep(this.editForm)
    },
  },
}
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-right: 0 !important;
}
.el-form-item__label {
  position: absolute;
}
.el-form-item__content {
  width: 100%;
  padding-left: 80px;
}
.el-select,
.el-input_inner {
  width: 100%;
}
::v-deep .el-form-item__label {
  text-align: left !important;
}
::v-deep .el-input--small .el-input__inner {
  width: 100% !important;
}
</style>
